import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "sonner";
import { api } from "./lib/api";
import Home from "./pages/Home";
import Profil from "./pages/Profil";
import Resultat from "./pages/Resultat";
import Methode from "./pages/Methode";
import Gainage from "./pages/Gainage";
import Tarifs from "./pages/Tarifs";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import Connexion from "./pages/Connexion";
import Merci from "./pages/Merci";
import Programme from "./pages/Programme";
import Coach from "./pages/Coach";
import ComingSoon from "./pages/ComingSoon";

/** Capture ?ref=... (parrainage) sur n'importe quelle page. */
function ReferralCapture() {
  const [params] = useSearchParams();
  useEffect(() => {
    const ref = params.get("ref");
    if (ref && ref.trim()) localStorage.setItem("km1_ref", ref.trim().toUpperCase());
  }, [params]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ReferralCapture />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="/resultat/:id" element={<Resultat />} />
        <Route path="/methode" element={<Methode />} />
        <Route path="/gainage" element={<Gainage />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/programme" element={<Programme />} />
        <Route path="/programme/merci" element={<Merci />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="*" element={<ComingSoon title="Page introuvable" description="Cette page n'existe pas. Reviens à l'accueil ou lance ton profil." />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
